import { pluginKey } from '../contextPanelPlugin';
export var applyChange = function applyChange(tr) {
  return tr.setMeta(pluginKey, {
    changed: true
  });
};